import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "selected-type-label" }
const _hoisted_2 = { class: "contacts-icon" }
const _hoisted_3 = { class: "selected-type-text" }

import { ContactType } from '@/features/contacts/models/contactType';
import MultiSelectPicker from '@/shared/components/MultiSelectPicker.vue';
import { computed, onMounted, PropType, ref } from 'vue';

interface TypeOption {
  type: string;
  display: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'MultiContactTypePicker',
  props: {
  modelValue: {
    type: Array as PropType<ContactType[]>,
    required: true,
  },
},
  emits: ["updated-type", "update:modelValue"],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

const typeOptions = toOptionObjects([ContactType.Visitor, ContactType.Lead, ContactType.User]);
const selectedOptions = ref<TypeOption[]>([]);
const isReady = ref(false);

const displayName = computed(() => {
  if (selectedOptions.value.length === 0 || selectedOptions.value.length === 3) {
    return 'Visitors, Leads, Users';
  }
  return selectedOptions.value.map((option: TypeOption) => getFriendlyName(option.type)).join(', ');
});

onMounted(() => {
  if (shouldAllTypesBeSelected(props.modelValue)) {
    selectedOptions.value = toOptionObjects([ContactType.Visitor, ContactType.Lead, ContactType.User]);
  } else {
    selectedOptions.value = toOptionObjects(props.modelValue);
  }
  isReady.value = true;
});

function onInput(newSelectedOptions: TypeOption[]) {
  const selectedTypes = newSelectedOptions.map((option) => option.type);
  emit('updated-type', selectedTypes);
  emit('update:modelValue', selectedTypes);
}

function toOptionObjects(options: string[]): TypeOption[] {
  return options.map((type) => ({ type, display: getFriendlyName(type) }));
}

function getFriendlyName(type: string) {
  return type.charAt(0).toUpperCase() + type.slice(1) + 's';
}

function shouldAllTypesBeSelected(types: string[]) {
  return !types || types.length === 0;
}

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (isReady.value)
    ? (_openBlock(), _createBlock(MultiSelectPicker, {
        key: 0,
        modelValue: selectedOptions.value,
        "onUpdate:modelValue": [
          _cache[0] || (_cache[0] = ($event: any) => ((selectedOptions).value = $event)),
          onInput
        ],
        options: _unref(typeOptions),
        "id-attribute": "type",
        "display-attribute": "display",
        "dropdown-alignment": "left"
      }, {
        "button-display": _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_font_awesome_icon, { icon: "user-friends" })
            ]),
            _createElementVNode("div", _hoisted_3, _toDisplayString(displayName.value), 1)
          ])
        ]),
        _: 1
      }, 8, ["modelValue", "options"]))
    : _createCommentVNode("", true)
}
}

})